module.exports = __webpack_public_path__ + "img/delete-red.e530d9aa.svg";